import { useFamilies } from './useFamilies';
import { getFamilyMemberClientIds } from '../utils';
import type { ParticipantFamily } from 'src/meetings/utils/event-utils';

export const useClientFamilyMap = (): Map<string, ParticipantFamily> => {
  const { families } = useFamilies();

  const map = new Map<string, ParticipantFamily>();
  for (const family of families) {
    for (const clientId of getFamilyMemberClientIds(family)) {
      map.set(clientId, { id: family.id, name: family.name });
    }
  }
  return map;
};
